import React from 'react';
import AboutContent from "../../FunctionalComponents/About/AboutContent";

const About = () => {
  return (
    <AboutContent />
  )
}

export default About;